import './productsListLink.scss'
import { ym } from "../../../shared/ym/ym";

interface ProductsListLinkProps {
   item: {
      name: string;
      sku: number;
      primary_image: string | string[];
      images: string[];
   }
   url: string;
}

function ProductsListLink({ item, url }: ProductsListLinkProps) {
   const handleClick = () => {
      ym(process.env.REACT_APP_YOUR_COUNTER_ID, "reachGoal", "button_click");
   };

   return (
      <a
         className='productsList__link'
         href={`${url}${item.sku}`}
         target="_blank"
         rel="noopener noreferrer"
         onClick={handleClick}
      >
         <img
            className='productsList__img'
            src={
               item.images && item.images.length > 0
                  ? Array.isArray(item.primary_image)
                     ? item.primary_image[0]
                     : item.primary_image : item.images[0]
            }
            alt={item.name}
         />
      </a>
   )
}

export default ProductsListLink